import { render, staticRenderFns } from "./walgorithm.vue?vue&type=template&id=3b264e8b"
import script from "./walgorithm.vue?vue&type=script&lang=js"
export * from "./walgorithm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports